import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
var Feature = /*#__PURE__*/function () {
  function Feature(node) {
    _classCallCheck(this, Feature);
    this.isMounted = false;
    this.node = node;
  }
  return _createClass(Feature, [{
    key: "update",
    value: function update() {}
  }]);
}();
export { Feature };